import { useLayoutEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import type { Props } from './types';

export const useRouterNonUiWidget = ({
  initializer,
  isXeroPromotionEnabled,
  isApplePayEnabled,
  isXeroAddOnEnabled,
  isStripeEnabled,
  isStripePhase2Enabled,
  isStripeScheduledDowngradeEnabled,
  isRedirectFromSecureEnabled,
  isAchMicroDepositsEnabled,
  externalHooks,
}: Props) => {
  const history = useHistory();
  const params = useParams();
  const isHidePromoCodesEnabled = externalHooks.useIsHidePromoCodesEnabled();

  useLayoutEffect(() => {
    initializer.routerNonUiInit(
      { history, params },
      {
        isXeroPromotionEnabled: Boolean(isXeroPromotionEnabled),
        isApplePayEnabled,
        isXeroAddOnEnabled: Boolean(isXeroAddOnEnabled),
        isStripeEnabled,
        isStripePhase2Enabled: Boolean(isStripePhase2Enabled),
        isStripeScheduledDowngradeEnabled: Boolean(isStripeScheduledDowngradeEnabled),
        isRedirectFromSecureEnabled: Boolean(isRedirectFromSecureEnabled),
        isAchMicroDepositsEnabled: Boolean(isAchMicroDepositsEnabled),
        isHidePromoCodesEnabled,
      }
    );
  }, [
    initializer,
    history,
    params,
    isApplePayEnabled,
    isXeroPromotionEnabled,
    isXeroAddOnEnabled,
    isStripeEnabled,
    isStripePhase2Enabled,
    isStripeScheduledDowngradeEnabled,
    isRedirectFromSecureEnabled,
    isAchMicroDepositsEnabled,
    externalHooks,
    isHidePromoCodesEnabled,
  ]);

  return null;
};
